import './index_web.css';

import CreateTeamPlayerRowFootball from '../create_team_player_row_football';
import { View } from '../../../component';

import { Key } from 'react';
import React from 'react';

interface Props {
  data: any;
  matchItem: any;
  onPressPlayer: any;
  selectedTab?: number;
  renderWhenEmpty: any;
  keeperList: any;
  defenderList: any;
  midfielderList: any;
  forwardList: any;
  lineupsOut?: boolean;
  keeperListDisable?: boolean;
  defenderListDisable?: boolean;
  midfielderListDisable?: boolean;
  forwardListDisable?: boolean;
  teamAPlayersCount?: number;
  teamBPlayersCount?: number;
  totalCreditCount?: number;
  substitutePlayers: any;
  sortName?: string;
  sortType?: string;
  onUpdateSortingList?: any;
}

const CreateTeamTabContentFootball = ({
  data,
  matchItem,
  onPressPlayer,

  lineupsOut,
  keeperListDisable,
  defenderListDisable,
  midfielderListDisable,
  forwardListDisable,
  teamAPlayersCount,
  teamBPlayersCount,
  totalCreditCount,
  substitutePlayers
}: Props) => {
  const renderItemPlayer = (item: { id: Key | null | undefined }) => (
    <CreateTeamPlayerRowFootball
      matchItem={matchItem}
      item={item}
      key={item.id}
      onPressPlayer={onPressPlayer}
      lineupsOut={lineupsOut}
      keeperListDisable={keeperListDisable}
      defenderListDisable={defenderListDisable}
      midfielderListDisable={midfielderListDisable}
      forwardListDisable={forwardListDisable}
      teamAPlayersCount={teamAPlayersCount}
      teamBPlayersCount={teamBPlayersCount}
      totalCreditCount={totalCreditCount}
      substitutePlayers={substitutePlayers}
    />
  );

  return (
    <View className={'create-team-tab-content-wrapper'}>
      {data.map((item: any) => renderItemPlayer(item))}
    </View>
  );
};
CreateTeamTabContentFootball.defaultProps = {
  selectedTeamPlayers: [],
  isEdit: false,
  substitutePlayers: []
};
export default React.memo(CreateTeamTabContentFootball);
